import {
  GetArticleByIdResponse,
  GetCategoriesResponse,
  GetCategoryByIdResponse,
  GetSectionByIdResponse,
  HelpCenterApiResponse,
  helpCenterBaseUrl,
  helpCenterRoutes,
} from "@twiliointernal/e2-commons-shared-definitions";
import Client from "./client";

export default class HelpCenterApiV2 extends Client {
  constructor() {
    super(helpCenterBaseUrl);
  }

  getCategories = async (): Promise<
    HelpCenterApiResponse<GetCategoriesResponse>
  > => {
    const response = await this.get({
      path: helpCenterRoutes.getCategories(),
    });

    return response as HelpCenterApiResponse<GetCategoriesResponse>;
  };

  getCategoryById = async (
    categoryId: string
  ): Promise<HelpCenterApiResponse<GetCategoryByIdResponse>> => {
    const response = await this.get({
      path: helpCenterRoutes.getCategoryById(categoryId),
    });

    return response as HelpCenterApiResponse<GetCategoryByIdResponse>;
  };

  getSectionById = async (
    sectionId: string
  ): Promise<HelpCenterApiResponse<GetSectionByIdResponse>> => {
    const response = await this.get({
      path: helpCenterRoutes.getSectionById(sectionId),
    });

    return response as HelpCenterApiResponse<GetSectionByIdResponse>;
  };

  getArticleById = async (
    articleId: string
  ): Promise<HelpCenterApiResponse<GetArticleByIdResponse>> => {
    const response = await this.get({
      path: helpCenterRoutes.getArticleById(articleId),
    });

    return response as HelpCenterApiResponse<GetArticleByIdResponse>;
  };
}
